import type {
	FormDataPublic,
	LifecycleHook,
} from '@atlassian/jira-ui-modifications-fields-configuration/src/common/utils/common/types';
import type { FieldConflict } from '../../actions/buffer-changes/types';
import { mapFieldPropertyToApiMethod } from '../map-field-property-to-api-method';
import {
	MULTI_APP_CONFLICT_CAUSE_FIELD,
	MULTI_APP_CONFLICT_CAUSE_SCREENTABS,
	MULTI_APP_CONFLICT_ERROR,
} from './constants';
import type { ConflictError } from './types';

type transformFieldErrorArgs = {
	lifecycleHook: LifecycleHook;
	conflict: FieldConflict;
	formData: FormDataPublic;
};
type transformScreenTabsErrorArgs = {
	lifecycleHook: LifecycleHook;
};

export const transformScreenTabsError = ({
	lifecycleHook,
}: transformScreenTabsErrorArgs): ConflictError => ({
	type: MULTI_APP_CONFLICT_ERROR,
	lifecycleHook,
	message: `Your app is conflicted on screen tabs with another UIM app in ${lifecycleHook}. Changes have been dismissed.`,
	cause: MULTI_APP_CONFLICT_CAUSE_SCREENTABS,
});

export const transformFieldError = ({
	lifecycleHook,
	conflict,
	formData,
}: transformFieldErrorArgs): ConflictError => {
	const method = mapFieldPropertyToApiMethod(conflict.property);
	return {
		type: MULTI_APP_CONFLICT_ERROR,
		lifecycleHook,
		message: `Your app is conflicted with another UIM app in ${lifecycleHook} on field: ${conflict.fieldId}, method: ${method}. Changes have been dismissed.`,
		fieldType: formData[conflict.fieldId]?.fieldType,
		fieldId: conflict.fieldId,
		method,
		cause: MULTI_APP_CONFLICT_CAUSE_FIELD,
	};
};
